export interface ApiRes<T> {
    data: T
    status: number
    error?: string
    isManager?: boolean
    pageInfo?: IPageInfo
    Message?: string
    code?: number
    success?: boolean
}

export enum ApiStats {
    Success = 200,
}

export interface IPageInfo {
    current_page?: number
    page_size?: number
    total_count?: number
    total_page?: number
}

export type Obj<T = never> = {foo: string} & T extends never ? unknown : {bar: T}
